<script>
import useConfiguration from "@/use/Configuration";
import {useSecurityStore} from "@/stores/Security";
import {onMounted} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const {backgroundColor} = useSharedData();
        const {loading, configurations, findAll, save} = useConfiguration();
        
        const securityStore = useSecurityStore();
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            loading,
            backgroundColor,
            configurations,
            save,
        }
    }
};
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('common.general') }}</v-tab>
                <v-tab>{{ $t('absence_request.auto_validation') }}</v-tab>
                <v-tab>{{ $t('common.email') }}</v-tab>
                
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="3">
                                <w-label :label="$t('common.color')"/>
                                <w-vuetify-color-picker
                                    v-model="configurations[131].strr"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[38].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_debt')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[39].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_pay_advance')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[40].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_absence_request')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[41].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_claim')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[42].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_admin_request')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[43].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_recruitment')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[45].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_pay')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-switch
                                    v-model="configurations[100].booll"
                                    inset
                                    :label="$t('absence_request.auto_validation_training_request')"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_object') }}</strong>
                                <w-text-field
                                    v-model="configurations[127].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_body') }}</strong>
                                <w-simple-text-area
                                    v-model="configurations[128].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs>
        </template>
    </w-app>
</template>